import { createApi } from "@reduxjs/toolkit/query/react";
import { pyrotchBaseUrl, axiosBaseQuery } from "../axios/AxiosInstance";
import { AuthRequest } from "../../models/Auth";

export const AuthApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "authapi",
  endpoints(build) {
    return {
      authLogin: build.mutation<any, AuthRequest>({
        query: ({email, password}: {email: string, password: string}) => ({
          url: `auth/login/user`,
          method: "POST",
          data: {
            email,
            password
          }
        }),
      }),
      registerUser: build.mutation<any, string>({
        query: (email: string) => ({
          url: `auth/register/user`,
          method: "POST",
          data: { email },
        }),
      }),
      verifyUser: build.mutation({
        query: ({ userId, otp }: { userId: number; otp: string }) => ({
          url: `auth/verify/user?userId=${userId}&otp=${otp}`,
          method: "POST",
        }),
      }),
      registerConfirm: build.mutation({
        query: ({ id, firstName, password }: { id: number; firstName: string; password: string }) => ({
          url: `auth/register-confirm/user`,
          method: "POST",
          data: {
            id,
            firstName,
            password,
          },
        }),
      }),
      changePassword: build.mutation({
        query: ({ oldPassword, newPassword  }: { oldPassword: string; newPassword : string }) => {
          const token = localStorage.getItem('authToken'); 
          return {
            url: `user/change-password?oldPassword=${oldPassword}&newPassword=${newPassword}`,
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };
        },
      }),
    };
  },
});

export const { useAuthLoginMutation, useRegisterUserMutation, useVerifyUserMutation, useRegisterConfirmMutation, useChangePasswordMutation } = AuthApi;
